module.exports = __webpack_public_path__ + "static/img/banner.2116be1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/news/banner.png
// module id = WTw+
// module chunks = 0